import { Model } from 'modules/core/lib/mobx-rest'

interface IIncidenceOption {
  [key: string]: any
}

class IncidenceOption extends Model<IIncidenceOption> {
  static urlRoot() {
    return '/bookkeepers_management/incidence_options'
  }
}

export default IncidenceOption
